import { Link } from 'react-router-dom';

const CommunityImpactSection = () => (
  <section className="py-16 md:py-20 bg-gradient-to-br from-[#1B6B3A] via-[#155530] to-[#0F3D22] text-white overflow-hidden relative">
    {/* Background pattern */}
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#74C69D] rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        
        {/* Left: Content */}
        <div className="w-full lg:w-1/2">
          <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-bold px-3 py-1.5 rounded-full mb-4">
            <i className="ri-calendar-event-line"></i>
            Host an E-Waste Event
          </div>
          
          <h2 className="text-3xl md:text-4xl font-extrabold leading-tight mb-5">
            Host an E-Waste Event —
            <span className="block text-[#74C69D]">Make an Impact in Your Community</span>
          </h2>
          
          <p className="text-green-100 text-base leading-relaxed mb-6">
            Turn your workplace or community event into something meaningful. We make it simple by providing the truck, collection bins, and expert team to handle everything from start to finish — including secure data destruction.
          </p>
          
          <p className="text-green-200 text-sm leading-relaxed mb-6">
            But it doesn't stop there. Usable devices are refurbished and placed into the hands of seniors and underserved families through <strong className="text-white">Bridge The Digital Divide</strong>, helping close the digital gap right here in our community.
          </p>

          {/* Impact stats */}
          <div className="grid grid-cols-3 gap-4 mb-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-2">
                <span className="text-xl">♻️</span>
              </div>
              <div className="text-xs font-bold text-green-100">Reduce Waste</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-2">
                <span className="text-xl">🔐</span>
              </div>
              <div className="text-xs font-bold text-green-100">Protect Data</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-2">
                <span className="text-xl">💻</span>
              </div>
              <div className="text-xs font-bold text-green-100">Empower Lives</div>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            <Link
              to="/events"
              className="inline-flex items-center gap-2 bg-white text-[#1B6B3A] font-bold px-6 py-3 rounded-md hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-calendar-check-line"></i>
              Let's Plan Your Event
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="tel:+12136001000"
              className="inline-flex items-center gap-2 bg-white/10 border border-white/30 text-white font-semibold px-6 py-3 rounded-md hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-phone-line"></i>
              (213) 600-1000
            </a>
          </div>
        </div>

        {/* Right: Image/Visual */}
        <div className="w-full lg:w-1/2">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/Community-e-waste-event-helping-bridge-the-digital-divide-in-Los-Angeles.jpg"
                alt="Community e-waste event helping bridge the digital divide in Los Angeles"
                className="w-full h-[320px] md:h-[420px] object-cover object-center"
                loading="lazy"
                width={700}
                height={500}
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -left-4 md:bottom-6 md:left-6 bg-white rounded-xl p-4 shadow-lg">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#E8F5EE] rounded-full">
                  <i className="ri-heart-fill text-[#1B6B3A] text-xl"></i>
                </div>
                <div>
                  <div className="text-[#1B6B3A] font-bold text-sm">Bridge The Digital Divide</div>
                  <div className="text-gray-500 text-xs">Refurbishing for families in need</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
);

export default CommunityImpactSection;